<template>
  <v-btn-form :title="title" @close="cancel()">
        <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            Подготовьте файл (xslx, csv), содержащий колонки: <b> дата</b>, <b>название</b> операции и <b> увеличение</b>, <b>уменьшение долга</b>.
          </v-flex>
          <v-layout align-center>
            <v-flex xs8 sm8>
            <template v-for="item in files">
              <div><v-tooltip bottom open-delay="500" max-width="20em">
              <div slot="activator">
              <v-chip
                :key = item.name
                small
                :text-color="errorFileMessage(item) ? 'error' : 'black'"
                @click="pickFile"
                close
                @input="item.remove"
                >
                <span class="text-xs-center">
                  {{item.name.slice(0, 30)}}
                </span>
              </v-chip>
                </div>
                <span style="overflow-wrap: break-word">{{item.name}}</span>
                <div class="error" light>{{errorFileMessage(item)}}</div>
              </v-tooltip></div>
            </template>
            <v-chip
              small
              disabled
              text-color="secondary"
              @click="pickFile"
              v-show="files.length === 0"
              >
              <span class="text-xs-center">
              Выберите файл
              </span>
            </v-chip>
            <input
              type="file"
              style="display: none"
              ref="image"
              @change="onFilePicked"
              :accept="getAcceptedFileFormat()"
              multiple
            >
            </v-flex>
          </v-layout>
        </v-layout>
        <v-flex py-3>
          Задайте соответствие полей документа и колонок в загружаемом файле
        </v-flex>
        <v-layout column>
            <b>
              <v-layout row align-center>
                <v-flex xs3 sm3 >
                <span>Поле</span>
                </v-flex>
                <v-flex xs6 sm4 px-2>
                <span>Название колонки</span>
                </v-flex>
                <v-flex xs3 sm4 px-2 >
                <span>Пример значения</span>
                </v-flex>
              </v-layout>
            </b>
            <template v-for="field in fields">
              <v-layout row align-center>
              <v-flex xs3 sm3 >
              <span>{{field.label}}{{field.key ? ' (идентификатор)' : ''}}</span>
              </v-flex>
              <v-flex xs6 sm4 px-2>
              <v-select
                hide-details
                v-model="field.number"
                :items="getNewFields()"
                item-value="value"
                item-text="text"
              >
              </v-select>
              </v-flex>
              <v-flex xs4 sm4 px-2 >
              <span>{{getValue(field)}}</span>
              </v-flex>
              </v-layout>
            </template>
          </v-layout>
        <v-flex py-3>
          Данные игнорируются если не удовлетворяют формату.
          <v-flex pl-3 xs8 sm6 v-if="exsistDate">
            <v-select
              label="Формат дат"
              hint="Выберите формат для полей даты"
              persistent-hint
              v-model="dateFormat"
              :items="[
                {value: 'DD.MM.YYYY', text: 'дд.мм.гггг'},
                {value: 'DD.MM.YY', text: 'дд.мм.гг'},
                {value: 'DD/MM/YYYY', text: 'дд/мм/гггг'},
                {value: 'DD/MM/YY', text: 'дд/мм/гг'},
                {value: 'YYYY-MM-DD', text: 'гггг-мм-дд'}
              ]"
            >
            </v-select>
          </v-flex>
        </v-flex>
      </v-card-text>
    <template #actions>
      <v-btn :disabled='!arrData || arrData.length === 0' @click="ok">ОК</v-btn>
      <v-spacer></v-spacer>
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../../api/formats'
  import files from '../../../api/files'
  import dialogs from '../../common/dialogs'
  import vBtnForm from '../../common/BtnForm'

  export default {
    name: 'calc-csv-loader',
    components: {vBtnForm},
    data: () => ({
      files: [],
      dateFormat: 'DD.MM.YYYY',
      delimiter: ',',
      textData: null,
      arrData: null
    }),
    watch: {
      textData: function (newVal, oldVal) {
        this.updateArrData()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      fields: {
        type: Array,
        default: []
      }
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll'
      }),
      title () {
        return 'Загрузите данные операций'
      },
      exsistDate () {
        return this.fields.find(f => f.type === 'DATE')
      }
    },
    methods: {
      errorFileMessage (file) {
        return files.errorFileMessage(file)
      },
      getAcceptedFileFormat () {
        return '.csv, .xlsx'
      },
      pickFile () {
        this.$refs.image.click()
      },
      onFilePicked (e) {
        const fs = Array.from(e.target.files)
        if (fs.length > 0) {
          fs.forEach((f) => files.readFileAsByteArray(f, (bytes) => {
            this.addFile(f, bytes)
          }))
        }
      },
      addFile (f, data) {
        const cb = (bytes) => {
          f.remove = (e) => !e && this.deleteFile(f)
          this.files = [f]
          this.textData = bytes
        }
        const cbErr = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при экспорте данных из 1С '})
        }
        files.convertToCsv(f, data, cb, cbErr)
      },
      deleteFile (file) {
        this.files = this.files.filter(f => formats.compareString(file.name, f.name) !== 0)
      },
      getNewFields () {
        let result = [{value: null, text: '(не задано)'}]
        if (this.arrData && this.arrData[0]) {
          this.arrData[0].forEach((value, key) => {
            result.push({value: key, text: value})
          })
        }
        return result
      },
      getValue (item) {
        return this.arrData && this.arrData[1] ? this.arrData[1][item.number] : ''
      },
      ok () {
        let result = files.import(this.fields, this.arrData, this.dateFormat)
        if (Object.keys(result).length > 0 && !Object.keys(result)[0]) {
          dialogs.message(this, 'Совет', 'Поле Идентификатора должно быть заполненным')
        } else {
          dialogs.confirm(this,
            'Подтвердите',
            `Загрузить данные об операциях (${Object.keys(result).length})?`,
            (self) => {
              console.log('ok', result)
              this.$emit('change', result)
              this.cancel()
            })
        }
      },
      cancel () {
        this.$emit('close')
        this.item = null
      },
      updateArrData () {
        let arrData = files.parseCsv(files.decode(this.textData))
        // skip empty lines
        while (arrData.length > 0 && (arrData[0].join('').length === 0)) {
          arrData.shift()
        }
        this.arrData = arrData
      }
    }
  }

</script>




// WEBPACK FOOTER //
// CalcCSVLoader.vue?0cebdf8e